import React, { useState } from "react";
import { GET_LIST, Toolbar, SaveButton, NumberInput } from "react-admin";
import { Card } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import moment_tz from 'moment-timezone';
import {
  map,
  curry,
  range,
  filter,
  propEq,
  isNil
} from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { API_ROOT } from "../api-config";

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  centerAlignedCell: { textAlign: "center" },
  title: { backgroundColor: "#ff9800" },
  blackBold: { fontWeight: "bold", color: "black" },
  boldCell: { fontWeight: "bold" },
  widthTable: {
    marginLeft: "10px",
    width: "100%",
    minWidth: "600px",
  },
  flex: { display: "flex" },
  flexResponsive: {
    display: "flex",
    overflowX: "auto",
    width: "100%",
  },
  formRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    gap: "12px",
    margin: "10px 0",
  },
  formField: {
    minWidth: "220px",
  },
  valueWithTrend: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    fontSize: "0.8rem",
  },
  compactHeaderCell: {
    fontSize: "0.85rem",
    padding: "6px 8px",
  },
  compactCell: {
    fontSize: "0.8rem",
    padding: "4px 8px",
  },
};

const METRICS_CONFIG = [
  { key: "guideIMT", label: "G. IMT" },
  { key: "guidedP4M", label: "G. P4M" },
  { key: "selfguidedIMT", label: "SG. IMT" },
  { key: "selfGuidedP4M", label: "SG. P4M" },
  { key: "totalG", label: "Total G." },
  { key: "totalSG", label: "Total SG." },
  { key: "rentals", label: "Rentals" },
  { key: "yearTotal", label: "Years Totals" },
];

const TREND_ICONS = {
  up: "▲",
  down: "▼",
  na: "●",
  flat: "–",
};

const TREND_COLORS = {
  green: "#2e7d32",
  red: "#c62828",
  yellow: "#f9a825",
  gray: "#757575",
};

const formatValue = (value) => {
  const numeric = Number(value) || 0;
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numeric);
};

const normalizeNumber = (value) => {
  const parsed = Number(value);
  if (Number.isNaN(parsed) || !Number.isFinite(parsed)) {
    return 0;
  }
  return parsed;
};

const calculateTrend = (currentValue, previousValue) => {
  const current = normalizeNumber(currentValue);
  const previous = previousValue === undefined || previousValue === null
    ? null
    : normalizeNumber(previousValue);

  if (previous === null) {
    return { icon: "na", color: "yellow", label: "N/A" };
  }

  if (previous === 0) {
    if (current === 0) {
      return { icon: "flat", color: "gray", label: "0%" };
    }

    if (current > 0) {
      return { icon: "up", color: "green", label: "+100%" };
    }

    if (current < 0) {
      return { icon: "down", color: "red", label: "-100%" };
    }
  }

  const variation = ((current - previous) / previous) * 100;

  let rounded = Number.isFinite(variation)
    ? Number(variation.toFixed(1))
    : 0;

  if (Object.is(rounded, -0)) {
    rounded = 0;
  }

  if (rounded === 0) {
    return { icon: "flat", color: "gray", label: "0%" };
  }

  if (rounded > 0) {
    return {
      icon: "up",
      color: "green",
      label: `+${rounded}%`,
    };
  }

  return {
    icon: "down",
    color: "red",
    label: `${rounded}%`,
  };
};

const TrendIndicator = ({ trend }) => {
  if (!trend) {
    return null;
  }

 /* if (trend.icon === 'na') {
    return null;
  }*/

  const color = TREND_COLORS[trend.color] || "inherit";

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        color,
        fontWeight: "bold",
      }}
    >
      <span style={{ color }}>{TREND_ICONS[trend.icon] || TREND_ICONS.na}</span>
      <span style={{ fontSize: '10px' }}>{trend.label}</span>
    </span>
  );
};

let dataSetAll = [];
let dataSetRentals = [];
let dataSetTours = [];
let dataSetToursGuided = [];
let dataSetOld = [];
let yearsArray = [];
let locationJson = null;

const StartForm = styled.div({
  margin: "30px",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "800px",
  //   height: "29rem",
  justifyContent: "space-between"
});

const useStyles = styled.div({
  backgroundColor: "transparent"
});
class reportFutureIncome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      numberOfMonths: 2,
      yearsStart: 2016,
      locationsArray: null,
      yearsEnd: moment()
        .startOf("year")
        .format("YYYYMMDD"),
      optDateBegin: moment().startOf("year").format("YYYY-MM-DD"), // 1 de enero del año actual
      optDateEnd: null,
      selectedDay: '',
      selectedMonth: '',
      loading: false,
      showTables: false,
      setLoading: false,
      exportData: [],
      setExportData: [],
      DataSet: [],
      month: moment()
        .startOf("month")
        .format("YYYYMMDD")
    };
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    const startDate = moment().startOf("year").format("YYYYMMDD"); // 1 de enero del año actual
    const endDate = moment().format("YYYYMMDD");
    const optDateBegin = moment().startOf("year").format("YYYY-MM-DD");
    await this.updateState(startDate, endDate, optDateBegin, null, null);
  }

  updateState = async (
    startDate,
    endDate,
    optDateBegin,
    optDateEnd
  ) => {
    const numberOfMonths = moment(endDate).diff(moment(startDate), "months");
    this.setState({
      numberOfMonths,
      isLoading: false,
      startDate,
      endDate,
      month: moment(startDate).format("YYYYMMDD"),
      optDateBegin,
      optDateEnd
    });
  };

  sortedDayList = (start, end) => {
    const add = (day, offset) => day.clone().add(offset, "days");
    return map(curry(add)(start), range(0, end.diff(start, "days") + 1));
  };

  // Función helper para obtener los días válidos según el mes
  getDaysInMonth = (month) => {
    if (!month || month === '') return 31;
    const monthIndex = parseInt(month) - 1; // Los meses en moment son 0-11
    const currentYear = moment().year();
    return moment().year(currentYear).month(monthIndex).daysInMonth();
  };

  // Handler para cambio de mes
  handleMonthChange = (event) => {
    const selectedMonth = event.target.value;
    const currentDay = this.state.selectedDay;
    
    // Validar que el día actual sea válido para el nuevo mes
    const maxDays = this.getDaysInMonth(selectedMonth);
    let validDay = currentDay;
    
    if (currentDay && parseInt(currentDay) > maxDays) {
      validDay = maxDays.toString();
    }
    
    this.setState({ 
      selectedMonth: selectedMonth,
      selectedDay: validDay
    }, () => {
      this.updateDateEnd();
    });
  };

  // Handler para cambio de día
  handleDayChange = (event) => {
    const selectedDay = event.target.value;
    this.setState({ selectedDay: selectedDay }, () => {
      this.updateDateEnd();
    });
  };

  // Actualizar optDateEnd cuando cambian día o mes
  updateDateEnd = () => {
    const { selectedDay, selectedMonth } = this.state;
    
    if (selectedDay && selectedMonth) {
      const currentYear = moment().year();
      const monthIndex = parseInt(selectedMonth) - 1; // Los meses en moment son 0-11
      const day = parseInt(selectedDay);
      
      // Validar que el día sea válido para el mes
      const maxDays = this.getDaysInMonth(selectedMonth);
      const validDay = Math.min(day, maxDays);
      
      const finalDate = moment().year(currentYear).month(monthIndex).date(validDay);
      this.setState({ optDateEnd: finalDate });
    }
  };

  handleDateTimeChange = (event, fieldName) => {
    // eslint-disable-next-line no-underscore-dangle
    if (!isNil(event)) {
      this.setState({ [fieldName]: event });
    }
  };

  handleChange = () => {
    dataSetRentals = [];
    dataSetTours = [];
    dataSetToursGuided = [];
    dataSetOld = [];
    // Validamos que día y mes estén seleccionados
    // La fecha inicial siempre será 1 de enero del año actual
    if (this.state.selectedDay && this.state.selectedMonth && this.state.optDateEnd !== null && this.state.optDateEnd !== '') {
      this.setState({ exportData: [], loading: true, showTables: true });
      this.getReports();
    }
  };

  async getReports() {
    // Fecha inicial: 1 de enero del año actual
    const eventDateStart = moment().startOf("year").format('YYYY-MM-DD');
    // Fecha final: día y mes seleccionados + año actual
    const eventDateEnd = moment(this.state.optDateEnd._d).format('YYYY-MM-DD');
    const dataProvider = await dataProviderFactory("rest");
    const reportFutureIncome = dataProvider(GET_LIST, "reports/reportFutureIncome", {
      filter: {
        startDate: eventDateStart,
        endDate: eventDateEnd,
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    reportFutureIncome.then(async (result) => {
      this.state.loading = false;
      dataSetRentals = result.data;
      dataSetAll = result.data;
      dataSetTours = result.data.tours;
      dataSetToursGuided = result.data.selfGuided;
      dataSetOld = result.data;
      const tipoT = dataSetOld.filter(r => r.type === 'T');
      const tipoR = dataSetOld.filter(r => r.type === 'R');
      dataSetRentals = tipoR
      dataSetTours = tipoT
     
      // Obtenemos una lista de todos los años disponibles
      yearsArray = Array.from(new Set(dataSetRentals.map(item => item.years)));
    
      const dataSet = [{
        columns: [
          { title: "Year", style: { font: { sz: "14", bold: true }, fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } } }, width: { wpx: 125 } }, // width in pixels
          { title: "Location", style: { font: { sz: "14", bold: true }, fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } } }, width: { wpx: 125 } }, // width in pixels
          { title: "Total", style: { font: { sz: "14", bold: true }, fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } } }, width: { wpx: 200 } }, // width in pixels                    
        ],
        data: dataSetRentals.map((data) => [
          { value: (data.years != null) ? new Intl.NumberFormat().format(data.years) : '', style: { font: { sz: "12" } } },
          { value: (data.location != null) ? data.location : '', style: { font: { sz: "12" } } },
          { value: (data.total != null) ? data.total : '', style: { font: { sz: "12" } } }
        ])
      }];

      this.setState({ loading: false, exportData: tipoR, DataSet: dataSet });
      return result.data;
    })
    .catch((error) => {
      this.state.loading = false;
    });
  }

  async fetchLocations() {
    const dataProvider = await dataProviderFactory("rest");
    const locations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 50
      },
      sort: { field: 'id', order: "DESC" }
    });

    const baseLocations = filter(location => {
      return isNil(location.base_location_id) && !propEq("location_name", "Other", location);
    }, locations.data);
    locationJson = baseLocations
    this.setState({ locations: baseLocations });
  }

  async getReportsDownload(startDate, endDate) {

    let data = {
      startDate: startDate,
      endDate: endDate
    };

    const response = await fetch(`${API_ROOT}/reports/download`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.token}`,
      },
      body: JSON.stringify(data)
    });

    let commits = await response.json(); 

    let a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    // a.href = 'data:' + registro.mimeType + ';base64,' + registro.base64;
    a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${commits.data}`;
    a.download = `Metrics.xlsx`;
    a.click();
    a.remove();
  }

  render() {
    const {
      isLoading,
      month,
      optDateBegin,
      optDateEnd,
    } = this.state;

    const { classes, ...props } = this.props;

    if (isLoading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    function getColorByLocation(localidad, objetos) {
      // Verificar si objetos es un arreglo y no está vacío
      if (Array.isArray(objetos) && objetos.length > 0) {
        for (let i = 0; i < objetos.length; i++) {
          if (objetos[i].location_name === localidad) {
            return objetos[i].color;
          }
        }
      }
      return null; // Si no se encuentra la localidad o el arreglo es vacío, devolvemos null
    }

    const totalsByLocationAndYear = {};
    dataSetRentals.forEach(item => {
      totalsByLocationAndYear[item.location] = totalsByLocationAndYear[item.location] || {};
      totalsByLocationAndYear[item.location][item.color] = getColorByLocation(item.location, this.locationsArray)
      // Guardar el valor numérico para formatearlo en el render
      totalsByLocationAndYear[item.location][item.years] = normalizeNumber(item.total);
    });

    // Agrupar tours por año (sumando todas las localidades)
    const toursByYear = {};
    dataSetTours.forEach(item => {
      const year = item.years;
      if (!toursByYear[year]) {
        toursByYear[year] = {
          countGuideIMT: 0,
          countPassengerGuideIMT: 0,
          countRiderGuideIMT: 0,
          countSelfguidedIMT: 0,
          countPassengerSelfguidedIMT: 0,
          countRiderSelfguidedIMT: 0,
          countGuidedP4M: 0,
          countPassengerGuidedP4M: 0,
          countRiderGuidedP4M: 0,
          countSelfGuidedP4M: 0,
          countPassengerSelfGuidedP4M: 0,
          countRiderSelfGuidedP4M: 0,
        };
      }
      toursByYear[year].countGuideIMT += normalizeNumber(item.countGuideIMT || 0);
      toursByYear[year].countPassengerGuideIMT += normalizeNumber(item.countPassengerGuideIMT || 0);
      toursByYear[year].countRiderGuideIMT += normalizeNumber(item.countRiderGuideIMT || 0);
      toursByYear[year].countSelfguidedIMT += normalizeNumber(item.countSelfguidedIMT || 0);
      toursByYear[year].countPassengerSelfguidedIMT += normalizeNumber(item.countPassengerSelfguidedIMT || 0);
      toursByYear[year].countRiderSelfguidedIMT += normalizeNumber(item.countRiderSelfguidedIMT || 0);
      toursByYear[year].countGuidedP4M += normalizeNumber(item.countGuidedP4M || 0);
      toursByYear[year].countPassengerGuidedP4M += normalizeNumber(item.countPassengerGuidedP4M || 0);
      toursByYear[year].countRiderGuidedP4M += normalizeNumber(item.countRiderGuidedP4M || 0);
      toursByYear[year].countSelfGuidedP4M += normalizeNumber(item.countSelfGuidedP4M || 0);
      toursByYear[year].countPassengerSelfGuidedP4M += normalizeNumber(item.countPassengerSelfGuidedP4M || 0);
      toursByYear[year].countRiderSelfGuidedP4M += normalizeNumber(item.countRiderSelfGuidedP4M || 0);
    });

    // Obtener años únicos de tours y ordenarlos
    const toursYearsArray = Object.keys(toursByYear).map(y => Number(y)).sort((a, b) => a - b);

    const startDate = moment().startOf("year").format("DD-MMM");
    const endDate = this.state.optDateEnd 
      ? moment(this.state.optDateEnd).format("DD-MMM")
      : '';

    const PostCreateToolbar = props => 
      <Toolbar {...props} style={{ backgroundColor: 'transparent' }}>
        <SaveButton label="Generate" type="submit" onClick={this.handleChange} />
      </Toolbar>;
    const salesByYear = {};
    dataSetAll.forEach(item => {
      const yearKey = item.years;
      if (!salesByYear[yearKey]) {
        salesByYear[yearKey] = {
          rentals: 0,
          tours: 0,
          selfguidedIMT: 0,
          guideIMT: 0,
          guidedP4M: 0,
          selfGuidedP4M: 0,
          totalG: 0,
          totalSG: 0,
        };
      }

      const bucket = salesByYear[yearKey];

      if (item.type === 'R') {
        bucket.rentals += normalizeNumber(item.total);
      } else if (item.type === 'T') {
        bucket.tours += normalizeNumber(item.total);
        bucket.selfguidedIMT += normalizeNumber(item.selfguidedIMT);
        bucket.guideIMT += normalizeNumber(item.guideIMT);
        bucket.guidedP4M += normalizeNumber(item.guidedP4M);
        bucket.selfGuidedP4M += normalizeNumber(item.selfGuidedP4M);
        bucket.totalG = bucket.guideIMT + bucket.guidedP4M;
        bucket.totalSG = bucket.selfguidedIMT + bucket.selfGuidedP4M;
      }
    });

    const sortedYears = Object.keys(salesByYear)
      .map(year => Number(year))
      .sort((a, b) => a - b);

    const yearlyData = sortedYears.map(year => {
      const metrics = salesByYear[year] || {};
      const totalG = normalizeNumber(metrics.totalG);
      const totalSG = normalizeNumber(metrics.totalSG);
      const rentalsValue = normalizeNumber(metrics.rentals);
      const yearTotal = totalG + totalSG + rentalsValue;

      return {
        year,
        ...metrics,
        totalG,
        totalSG,
        rentals: rentalsValue,
        yearTotal,
      };
    });

    const yearlyDataWithTrends = yearlyData.map((entry, index) => {
      const previous = index > 0 ? yearlyData[index - 1] : null;
      const trends = METRICS_CONFIG.reduce((acc, metric) => {
        const currentValue = entry[metric.key];
        const previousValue = previous ? previous[metric.key] : null;
        acc[metric.key] = calculateTrend(currentValue, previousValue);
        return acc;
      }, {});

      return { ...entry, trends };
    });

    const totalColumns = 1 + METRICS_CONFIG.length;
    return (
      <Card>
        <StartForm>
          <h3>Future Income Report By Range</h3>
          <div style={styles.formRow}>
            <FormControl style={styles.formField}>
              <InputLabel id="month-select-label">Month</InputLabel>
              <Select
                labelId="month-select-label"
                id="month-select"
                value={this.state.selectedMonth}
                onChange={this.handleMonthChange}
                label="Month"
              >
                <MenuItem value="1">January</MenuItem>
                <MenuItem value="2">February</MenuItem>
                <MenuItem value="3">March</MenuItem>
                <MenuItem value="4">April</MenuItem>
                <MenuItem value="5">May</MenuItem>
                <MenuItem value="6">June</MenuItem>
                <MenuItem value="7">July</MenuItem>
                <MenuItem value="8">August</MenuItem>
                <MenuItem value="9">September</MenuItem>
                <MenuItem value="10">October</MenuItem>
                <MenuItem value="11">November</MenuItem>
                <MenuItem value="12">December</MenuItem>
              </Select>
            </FormControl>
            <FormControl style={styles.formField}>
              <InputLabel id="day-select-label">Day</InputLabel>
              <Select
                labelId="day-select-label"
                id="day-select"
                value={this.state.selectedDay}
                onChange={this.handleDayChange}
                label="Day"
                disabled={!this.state.selectedMonth}
              >
                {Array.from({ length: this.getDaysInMonth(this.state.selectedMonth) }, (_, i) => i + 1).map(day => (
                  <MenuItem key={day} value={day.toString()}>
                    {day}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
           {/*  <div style={{ marginTop: '8px', fontSize: '0.9rem', color: '#666', alignSelf: 'flex-end' }}>
              <span>Fecha inicial automática: 1 de enero {moment().year()}</span>
            </div> */}
          </div>
          <PostCreateToolbar />
        </StartForm>
        {this.state.showTables ? (
          <div style={styles.flexResponsive}>
            <Table style={styles.widthTable}>
              <TableHead>
                <TableRow >
                  <TableCell colSpan={totalColumns} style={{ ...styles.leftAlignedCell, ...styles.compactHeaderCell }}>
                    <h3>TOURS {/* ({startDate} to {endDate}) */}</h3>
                  </TableCell>
                </TableRow>
                <TableRow style={styles.title}>
                  <TableCell style={{ ...styles.leftAlignedCell, ...styles.blackBold, ...styles.compactHeaderCell}}>Years</TableCell>
                  {METRICS_CONFIG.map(metric => (
                    <TableCell
                      key={metric.key}
                      style={{ ...styles.leftAlignedCell, ...styles.blackBold, ...styles.compactHeaderCell}}
                    >
                      {metric.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {yearlyDataWithTrends.map(row => (
                  <TableRow key={row.year}>
                    <TableCell style={{ ...styles.leftAlignedCell, ...styles.compactCell}}>
                     <span style={{ fontSize: '12px' }}>{row.year}</span>
                    </TableCell>
                    {METRICS_CONFIG.map(metric => (
                      <TableCell
                        key={metric.key}
                        style={{ ...styles.leftAlignedCell, ...styles.compactCell}}
                      >
                        <span style={styles.valueWithTrend}>
                          <span>{formatValue(row[metric.key])}</span>
                          <TrendIndicator trend={row.trends[metric.key]} />
                        </span>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : null}
        {this.state.showTables ? (
          <div style={styles.flexResponsive}>
            <Table style={styles.widthTable}>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={5} style={{ ...styles.leftAlignedCell, ...styles.compactHeaderCell }}>
                    <h3>TOURS (Rider / Passenger) {/* ({startDate} to {endDate}) */}</h3>
                  </TableCell>
                </TableRow>
                <TableRow style={styles.title}>
                  <TableCell style={{ ...styles.leftAlignedCell, ...styles.blackBold, ...styles.compactHeaderCell}}>Years</TableCell>
                  <TableCell style={{ ...styles.leftAlignedCell, ...styles.blackBold, ...styles.compactHeaderCell}}>
                    <span style={{ fontSize: '12px' }}>G. IMT</span>
                  </TableCell>
                  <TableCell style={{ ...styles.leftAlignedCell, ...styles.blackBold, ...styles.compactHeaderCell}}>
                    <span style={{ fontSize: '12px' }}>G. P4M</span>
                  </TableCell>
                  <TableCell style={{ ...styles.leftAlignedCell, ...styles.blackBold, ...styles.compactHeaderCell}}>
                    <span style={{ fontSize: '12px' }}>SG. IMT</span>
                  </TableCell>
                  <TableCell style={{ ...styles.leftAlignedCell, ...styles.blackBold, ...styles.compactHeaderCell}}>
                    <span style={{ fontSize: '12px' }}>SG. P4M</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {toursYearsArray.map(year => {
                  const yearData = toursByYear[year] || {
                    countGuideIMT: 0,
                    countPassengerGuideIMT: 0,
                    countRiderGuideIMT: 0,
                    countSelfguidedIMT: 0,
                    countPassengerSelfguidedIMT: 0,
                    countRiderSelfguidedIMT: 0,
                    countGuidedP4M: 0,
                    countPassengerGuidedP4M: 0,
                    countRiderGuidedP4M: 0,
                    countSelfGuidedP4M: 0,
                    countPassengerSelfGuidedP4M: 0,
                    countRiderSelfGuidedP4M: 0,
                  };
                  return (
                    <TableRow key={year}>
                      <TableCell style={{ ...styles.leftAlignedCell, ...styles.compactCell}}>
                        <span style={{ fontSize: '12px' }}>{year}</span>
                      </TableCell>
                      <TableCell style={{ ...styles.leftAlignedCell, ...styles.compactCell}}>
                        <span>{yearData.countRiderGuideIMT} / {yearData.countPassengerGuideIMT}</span>
                      </TableCell>
                      <TableCell style={{ ...styles.leftAlignedCell, ...styles.compactCell}}>
                        <span>{yearData.countRiderGuidedP4M} / {yearData.countPassengerGuidedP4M}</span>
                      </TableCell>
                      <TableCell style={{ ...styles.leftAlignedCell, ...styles.compactCell}}>
                        <span>{yearData.countRiderSelfguidedIMT} / {yearData.countPassengerSelfguidedIMT}</span>
                      </TableCell>
                      <TableCell style={{ ...styles.leftAlignedCell, ...styles.compactCell}}>
                        <span>{yearData.countRiderSelfGuidedP4M} / {yearData.countPassengerSelfGuidedP4M}</span>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        ) : null}
       {this.state.showTables ? (
          <div style={styles.flexResponsive}>
            <Table style={styles.widthTable}>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={1 + yearsArray.length} style={{ ...styles.leftAlignedCell, ...styles.compactHeaderCell }}>
                    <h3>RENTALS {/* ({startDate} to {endDate}) */}</h3>
                  </TableCell>
                </TableRow>
                <TableRow style={styles.title}>
                  <TableCell style={{ ...styles.leftAlignedCell, ...styles.blackBold, ...styles.compactHeaderCell}}>Location</TableCell>
                  {yearsArray.map(year => (
                    <TableCell key={year} style={{ ...styles.leftAlignedCell, ...styles.blackBold, ...styles.compactHeaderCell}}>
                      <span style={{ fontSize: '12px' }}>{year}</span>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(totalsByLocationAndYear).map(location => (
                  <TableRow key={location}>
                    <TableCell 
                      key={location} 
                      id={location} 
                      style={{ 
                        ...styles.leftAlignedCell, 
                        ...styles.compactCell,
                        backgroundColor: getColorByLocation(location, locationJson) 
                      }}
                    >
                      <span style={{ fontSize: '12px' }}>{location}</span>
                    </TableCell>
                    {yearsArray.map(year => (
                      <TableCell key={year} style={{ ...styles.leftAlignedCell, ...styles.compactCell}}>
                        <span style={styles.valueWithTrend}>
                          <span>{formatValue(totalsByLocationAndYear[location][year] || 0)}</span>
                        </span>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : null}
        <div style={{ marginBottom: '10px'}}></div>
      </Card>
    );
  }
}

export default reportFutureIncome;


// WEBPACK FOOTER //
// ./src/components/reportFutureIncome.js